<template>
  <div id="app">
    <div id="nav"></div>
    <router-view @authenticated="setAuthenticated" />
  </div>
</template>
<script>
  export default {
    name: "App",
    data() {
      return {
        authenticated: false
      };
    },
    mounted() {
      if (!this.authenticated) {
        this.$router.replace({ name: "login" });
      }
    },
    methods: {
      setAuthenticated(status) {
        this.authenticated = status;
      },
      logout() {
        this.authenticated = false;
      }
    }
  };
</script>
<style lang="scss">
 
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  .left {
    padding: 30px 0 0 30px;
    text-align: left;
  }
  .link {
    svg {
      margin-right: 10px;
    }
    color: $fontColor;
    text-decoration: none;
    font-size: 0.85em;
  }
  body {
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: "Poppins", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $fontColor;
  }
  .flex {
    @include flexbox;
    @include flex-direction(row);
    @include justify-content(space-between);
    @include align-items(flex-start);
      @include media-query(1000px) {
        flex-wrap: wrap;
      }
    @include media-query(460px){
          display:block;          
    }
  }
  .center {
    text-align: center;
  }
  .icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    stroke-width: 0;
    stroke: currentColor;
    fill: currentColor;
  }
  .icon-hossa_logo {
    width: 7.283203125em;
    color: $secondColor;
  }
  .bigLogo {
    font-size: 2em;
  }
  .mediumLogo {
    font-size: 1.5em;
  }
  button {
    display: inline-block;
    background: $secondColor;
    color: #fff;
    padding: 15px;
  }
  strong {
    font-weight: 500;
  }
  .container {
    max-width: 1200px;
    margin: 0 auto;
    .col {
      text-align: left;
      padding: 15px 30px 30px 30px;
    }
    .col6 {
      width: 50%;
    }
    .col,.col6{
      @include media-query(460px){
          width:100%       
      }
    }
  }
  .container2 {
    max-width: 1700px;
    margin: 0 auto;
  }
  .loginForm {
    background: $lightGray;
    padding: 30px 60px;
  }
  h2 {
    color: $secondColor;
    text-transform: uppercase;
    font-weight: bold;
  }
  #nav {
    padding: 30px;
    background: $color;
    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .footer {

    &.hasBg {
      .flex {
        @include justify-content(center);
        @include align-items(center);
      
      }
    }
  }
</style>
